import {
  FETCH_SUPPLIERS_START,
  FETCH_SUPPLIERS_SUCCESS,
  FETCH_SUPPLIERS_ERROR,
  SET_SELECTED_SUPPLIER,
  SET_SELECTED_ENTITY,
} from '../reducer/reducer';
import { getCompanySuppliersAction } from './action';

// Action Creators
export const fetchSuppliersStart = () => ({
  type: FETCH_SUPPLIERS_START,
});

export const fetchSuppliersSuccess = (suppliers) => ({
  type: FETCH_SUPPLIERS_SUCCESS,
  payload: suppliers,
});

export const fetchSuppliersError = (error) => ({
  type: FETCH_SUPPLIERS_ERROR,
  payload: error,
});

export const setSelectedSupplier = (supplierId) => ({
  type: SET_SELECTED_SUPPLIER,
  payload: supplierId,
});

export const setSelectedEntity = (entityId) => ({
  type: SET_SELECTED_ENTITY,
  payload: entityId,
});

// Thunk Action for fetching suppliers
export const fetchSuppliers = (module = 'default', params = {}) => {
  return async (dispatch) => {
    dispatch(fetchSuppliersStart());
    
    try {
      const { data, error, message } = await getCompanySuppliersAction(module, params);
      
      if (!error) {
        dispatch(fetchSuppliersSuccess(data));
      } else {
        dispatch(fetchSuppliersError(message || 'Failed to fetch suppliers'));
        throw new Error(message || 'Failed to fetch suppliers');
      }
    } catch (err) {
      dispatch(fetchSuppliersError(err.message));
      throw err;
    }
  };
};